// extracted by mini-css-extract-plugin
export default {"container":"SupplierRegister_container__LWO77","supplierForm":"SupplierRegister_supplierForm__ZeloZ","wrapper":"SupplierRegister_wrapper__1Obgf"};